module.exports = __webpack_public_path__ + "static/media/membership2026-adult-card.58ffda50.png";